const e = {
  name: "ArrowCircleDownFilled",
  dimensions: { width: 22, height: 22 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 22C17.07 22 22 17.07 22 11C22 4.93 17.07 -4.30994e-07 11 -9.61651e-07C4.93 -1.49231e-06 1.49231e-06 4.93 9.61651e-07 11C4.30994e-07 17.07 4.93 22 11 22ZM6.29 10.29L6.28 10.29C5.89 10.68 5.89 11.31 6.28 11.7L10.28 15.7C10.38 15.8 10.49 15.87 10.61 15.92C10.85 16.02 11.13 16.02 11.37 15.92C11.5 15.87 11.61 15.79 11.7 15.7L15.7 11.7C16.09 11.31 16.09 10.68 15.7 10.29C15.31 9.9 14.68 9.9 14.29 10.29L12 12.58L12 6.99C12 6.44 11.55 5.99 11 5.99C10.45 5.99 10 6.44 10 6.99L10 12.58L7.71 10.29C7.51 10.1 7.26 10 7 10C6.74 10 6.49 10.09 6.29 10.29Z" fill="currentColor"/>
    `
};
export {
  e as ArrowCircleDownFilled
};
